export const TimeConstants = {
     // Epoch for 04/01/2023 12:00am PT, the start date requested by PAC for applying bom validation
    beginBOMValidationEpoch: 1680332400000
}